import { lcResourcePreviewFragment } from 'humanity/components/lcResourcePreview';

/**
 * @type {String}
 */
export const lcRelatedArticlesFragment = `... on SectionLearningCenterRelatedArticles {
    title
    articlesCollection (limit: 15) {
      items {
        ${lcResourcePreviewFragment}
      }
    }
  }
`;
